// src/pages/About.jsx
import React from 'react';
import './About.css';
import '../styles/global.css'
//import ImageCarousel from '../components/imagecarousel';
import ThreePillars from '../components/threepillars.jsx';
import heroImg from '../images/aboutbanner.JPG'; 


import FadeInSection from '../components/fadeinsection.jsx';
import parents from '../images/parents.jpeg';
import classenvironment from '../images/classroomenvironment.jpg';
import graduation from '../images/graduation.JPG';

export default function About() {
  return (
    <div className="about-page">

      {/* Hero */}
      <div className="about-hero-section" style={{ backgroundImage: `url(${heroImg})` }}>
        <div className="about-hero-overlay">
          <div className='about-hero-container'>
            <h1 style={{ fontSize: '50px'}}>About Bright Beginning</h1>
            <p style={{ fontSize: '20px'}}>Committed to making every child feel safe, inspired, and empowered.</p>
          </div>
          
        </div>
      </div>

      <div  id="about" className='space'/>
      {/* About Us*/}
      <section className="story">
        <h1>About Us</h1>
        <p className="mid-paragraph">
          Bright Beginning is a nonprofit school that serves children from economically underprivileged backgrounds. The school was founded in
          2019 by Nahida Rahman, who has experience in the New York elementary education system. Currently the school has kindergarten to
          5th grade classes with around 180 students.
        </p>
        
      </section>


      {/* Our Vision*/}
      <section className="story">
        <h1>Our Vision</h1>
        <p className="mid-paragraph">To have a positive and meaningful impact on the lives of the children, and ensure they have a bright future ahead. We believe through education we can help fight poverty, discrimination and social inequality.</p>
        
      </section>

      {/* Full-width quote/stats banner */}
      <section className="about-banner-quote">
        <h3>"Education is the most powerful weapon to change the world." – Nelson Mandela</h3>
      </section>


      {/* Education, Food, Enrichment */}
      <ThreePillars/>

      {/* Image Carousel */}
      {/* <FadeInSection>
        <section className="about-carousel-images-container">
          <h2>Inside Bright Beginning</h2>
          <ImageCarousel />
        </section>
      </FadeInSection> */}
      
      {/* Classroom Environment */}
      <FadeInSection>
        <section className="about-parent-section" id="classenvironment">
          <div className="parent-text">
            <h2>Classroom Environment</h2>
            <p>
              Students are taught by qualified teachers. At our school we hope to foster self-confidence, integrity, collaboration and a sense of community
              among our students so they will continue to pursue lifelong learning opportunities, even after leaving Bright Beginning.
            </p>
          </div>
          <div className="parent-image">
            <img src={classenvironment} alt="Parent involvement" />
          </div>
        </section>
      </FadeInSection>

      {/* Parent Involvement */}
      <FadeInSection>
        <section className="about-parent-section" id="parentinvolvement">
          <div className="parent-text">
            <h2>Parents' Involvement</h2>
            <p>
              We hold parent teacher meetings once a month to discuss the progress of the children and encourage them to be
              engaged with their children's education. We also use this opportunity to raise awareness of issues such as family planning,
              disease prevention, nutrition and hygiene.
            </p>
          </div>
          <div className="parent-image">
            <img src={parents} alt="Parent involvement" />
          </div>
        </section>
      </FadeInSection>

      
      

      {/* Graduation Outcome Banner */}
      <FadeInSection>
        <section className="about-parent-section" id="postgrad">
          <div className="parent-text">
            <h2>Post Graduation</h2>
            <p>
              Upon graduating from Bright Beginning, many of our students have successfully transitioned to esteemed high schools, 
              including Uttara High School, Poroshmoni School, and the Islamic Education Society (IES).
            </p>
          </div>
          <div className="parent-image">
            <img src={graduation} alt="Parent involvement" />
          </div>
        </section>
      </FadeInSection>

        <div className = "space-large"/>

    </div>
  );
}
